import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  viewMode: localStorage.getItem('userViewPreference') || 'list',
};

export const viewPreferenceSlice = createSlice({
  name: 'viewPreference',
  initialState,
  reducers: {
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
      localStorage.setItem('userViewPreference', action.payload);
    },
  },
});

export const { setViewMode } = viewPreferenceSlice.actions;

export default viewPreferenceSlice.reducer;
